export const ActivityTeamLeadPermissions = {
  ActivityTeamLeadPermissions: {
    permissionsId: "9ace5f11-769f-4de6-7972-08dcaf947ea8",
    permissionsName: "Activity Team Lead",
    description: null,
    componentsId: null,
    components: null,
  },
};
